<template>
  <div>
    <div class="section1 safe-area">
      <pageTitle cn="教学成果认证" en="Official Teaching Accreditation" type="1"></pageTitle>
      <div class="page-flex-lr-center">
        <div class="lf">
          <div class="common-title-d1 mt-20">大会优质PBL课堂实践案例或将统一收录进中国教育学会国际教育分会官方案例库，面向全国中小学推广。教师完整赛事教学实践经历获得国家级学术机构权威认证，可作为职称评定、评优评先、校本课程开发核心加分材料，助力教师从课堂实践者成长为全国PBL教学示范引领者。</div>
          <div class="common-title-d2 mt-12">Outstanding PBL classroom practice cases from the conference may be compiled into the official case repository of the International Education Branch of the China Education Association for promotion to primary and secondary schools nationwide. Teachers’ complete teaching practice experiences from the competition will receive authoritative certification from a national-level academic institution, which can serve as key supporting materials for professional title evaluations, excellence awards, and school-based curriculum development, helping teachers grow from classroom practitioners into national PBL teaching role models and leaders.</div>
        </div>
        <div class="rt">
          <img :src="$env.imgUrl + 'study2-s1.png'" alt="">
        </div>
      </div>
    </div>
    <div class="section2" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <pageTitle cn="媒体成果传播" en="Global Media Exposure" type="2"></pageTitle>
        <div class="common-title-d3 mt-20">《中国日报21世纪英文报》或将开设大赛专属固定专栏，持续刊登优秀参赛学生项目、成长故事、非遗与科创创新作品。依托国际英文媒体平台向全球讲述中国青少年创新故事，为学生海外升学、背景提升提供权威媒体背书素材。</div>
        <div class="common-title-d4 mt-12">China Daily 21st Century may launch a dedicated, regular column for the competition to continuously feature outstanding student projects, stories of personal growth, and works related to intangible cultural heritage and scientific and technological innovation. Leveraging its international English-language media platform, the publication will share stories of Chinese youth innovation with the world, providing students with authoritative media endorsements to support their applications to overseas universities and enhance their profiles.</div>
        <img :src="$env.imgUrl + 'study2-s2.png?v=0727'" alt="">
      </div>
    </div>
    <div class="section3">
      <div class="safe-area">
        <pageTitle cn="双轨进修通道" en="Dual Training Pathways" type="1"></pageTitle>
        <div class="page-flex-lr-center-between">
          <div class="s3-item">
            <div class="cn">国内深耕</div>
            <div class="en">Deepening Our Presence in China</div>
            <img :src="$env.imgUrl + 'study2-s3-1.png'" alt="">
          </div>
          <div class="s3-item">
            <div class="cn">国际进阶</div>
            <div class="en">International Advancement</div>
            <img :src="$env.imgUrl + 'study2-s3-2.png?v=073117'" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style scoped lang="less">
.mt-20{
  margin-top: 20px;
}
.section1{
  padding: 30px 0 40px;
  .lf{
    width: 45%;
  }
  .rt{
    flex: 1;
    margin-left: 20px;
    img{
      width: 100%;
    }
  }
}
.section2{
  padding: 80px 0;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  img{
    width: 100%;
    margin-top: 20px;
  }
}
.section3 {
  padding: 20px 0 60px;
  .s3-item{
    width: 49%;
    text-align: center;
    .cn{
      margin-top: 20px;
      font-family: systh;
      font-size: 16px;
      color: #000;
    }
    .en{
      margin-top: 4px;
      font-family: systh;
      font-size: 10px;
      color: #000;
      margin-bottom: 20px;
    }
    img{
      width: 100%;
      height: auto;
    }
  }
}
</style>
